var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.860352H513V342.86H0V0.860352Z",
    fill: "#009B3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 20.1602L461.4 171.56L256.5 322.86L50.6 171.56L256.5 20.1602Z",
    fill: "#FEDF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 252.26C300.904 252.26 336.9 216.264 336.9 171.86C336.9 127.457 300.904 91.4604 256.5 91.4604C212.096 91.4604 176.1 127.457 176.1 171.86C176.1 216.264 212.096 252.26 256.5 252.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.9 166.561C202 166.561 188.5 168.661 175.8 172.561C176.4 216.461 212.1 251.861 256.1 251.861C283.3 251.861 307.4 238.261 321.9 217.561C297 186.561 258.7 166.561 215.9 166.561ZM334.9 186.861C335.8 181.861 336.4 176.761 336.4 171.461C336.4 127.061 300.4 91.0605 256 91.0605C222.9 91.0605 194.5 111.161 182.1 139.661C193 137.461 204.2 136.261 215.7 136.261C262.5 136.361 304.7 155.761 334.9 186.861Z",
    fill: "#002776"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.860352)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBr);
export default __webpack_public_path__ + "static/media/BR.3b63a8688ec8be8b8f07f9f9af923120.svg";
export { ForwardRef as ReactComponent };